import { render } from "./LimitOrderList.vue?vue&type=template&id=54d4663c&scoped=true"
import script from "./LimitOrderList.vue?vue&type=script&lang=js"
export * from "./LimitOrderList.vue?vue&type=script&lang=js"

import "./LimitOrderList.vue?vue&type=style&index=0&id=54d4663c&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d4663c"],['__file',"resources/js/components/LimitOrderList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54d4663c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54d4663c', __exports__)) {
    api.reload('54d4663c', __exports__)
  }
  
  module.hot.accept("./LimitOrderList.vue?vue&type=template&id=54d4663c&scoped=true", () => {
    api.rerender('54d4663c', render)
  })

}


export default __exports__